<template>
  <v-app-bar v-bind="appBarTopProps">
    <v-btn width="40" min-width="40"
           height="40"
           class="mr-5"
           plain
    >
      <img :src="require('@/assets/images/ico-prev.png')" alt="뒤로 가기"
           @click="$router.back()"
      >
    </v-btn>

    <v-toolbar-title>
      <img src="/images/common/h1-olens.png"
           alt="오렌즈"
           role="button"
           @click="$router.push({name: 'main'})"
      >
    </v-toolbar-title>

    <v-spacer />

    <v-text-field v-model="lazyQueryString"
                  outlined hide-details
                  clearable
                  placeholder="검색어를 입력해 주세요."
                  @keypress.enter="searchProduct"
    >
      <template #append>
        <v-btn  icon width="40" height="40"
               @click="searchProduct"
        >
          <v-img src="@/assets/images/search.png" width="40" height="40x" />
        </v-btn>
      </template>
    </v-text-field>
  </v-app-bar>
</template>

<script>

import moment from 'moment';

export default {
  name: 'SearchTopBar',
  props: {
    appBarTopProps: { type: Object, default: () => ({}) },
  },
  data: (vm) => ({
    queryString: vm.$route.query.queryString || null,
    lazyQueryString: vm.$route.query.queryString || null,
  }),
  computed: {
    computedQueryString () {
      return this.queryString;
    },
  },
  watch: {
    computedQueryString (newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }

      let query = {};

      if (this.queryString) {
        query[`queryString`] = this.queryString;
        this.setQueryString(this.queryString);
      }

      this.$router.push({ name: 'search', query });
    },
    '$route.query.queryString' () {
      this.lazyQueryString = this.$route.query.queryString;
      this.queryString = this.$route.query.queryString;
    },
  },
  methods: {
    searchProduct () {
      this.queryString = this.lazyQueryString;
    },
    setQueryString (queryString) {
      const recentQueryStrings = localStorage.getItem('recentQueryStrings') || JSON.stringify([]);
      let recentQueryList = JSON.parse(recentQueryStrings);
      const duplicatedIndex = recentQueryList.findIndex(item => item?.queryString === queryString);

      if (duplicatedIndex >= 0) {
        recentQueryList.splice(duplicatedIndex, 1);
      }

      recentQueryList.unshift({
        queryString,
        date: moment().format('YYYY-MM-DD'),
      });

      localStorage.setItem('recentQueryStrings', JSON.stringify(recentQueryList));
    },
  },
};
</script>
